import React from 'react'
import Typography from '../Typography'
import { ThemePaletteConfiguration } from '../../../../types/theme'

interface Props{
    title:string,
    content:string,
    style?:React.CSSProperties,
    contentColor?:keyof ThemePaletteConfiguration | undefined
}

export default function InfoBox({title,content,style,contentColor}:Props) {
  return (
    <div style={style}>
        <Typography  variant="label" className='mt-2'>
            {title} 
        </Typography>
        <Typography colorVariant={contentColor}  variant="label" style={{fontWeight:800}} className=''>
            {content}
        </Typography>
  </div>
  )
}
